import { fExecuteAPI } from "../../Server/Apis";
import {
  SaveWMINV04_GETROW,
  WMSGRV_GRVAttributes_GETROW,
} from "../../Server/ApiV2";
import {
  fAlertToast,
  fcovertToNumber,
  fCalculate_Detail,
  fcheck_null_undefine_replace_empty,
  Get_TransItemStockUOM,
} from "../../Utility/Utilitys";

import {
  Set_OutboundGRV_HeadObject_DrCrAccount,
  Set_WmsOutboundGRV_HeadObject_Set,
  Set_OutboundGRV_HeadObject_A_VocNo,
  Set_OutboundGRV_HeadObject_A_PayMode,
  Wms_HeadObject_Buyer_Set,
} from "./SliceWmsOutboundGRV";

import {
  vRdxUserInfo,
  vRdxtax,
  OutboundGRV,
  KernCAConfig,
} from "../../Redux/roStore";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css 
// const { tax1, tax2 } = vRdxtax();
// const vRdxUserInfoObj = vRdxUserInfo();
// const { HeadObject } = OutboundGRV();

export const ErrorMsg = {
  A_VocTyp: "",
  A_VocNo: "",
  A_PostDt: "",
  A_RefNo: "",
  A_RefDt: "",
  A_Type: "",
  A_PayMode: "",
  UnloadingBay: "",
  A_Party: "",
  A_PartyName: "",
  A_Curr: "",
  A_ExRate: "",
  A_Loc: "",
  TaxType: "",
  offer: "",
  A_Buyer: "",
  A_Buyername: "",
  A_CrAc: "",
  A_CrAcName: "",
  A_DrAc: "",
  A_DrAcName: "",
  A_Type: "",
  A_Rounding: "",
  A_DocStat: "",
  A_Taxable: "",
  xErrorMsg: "",
};
export const ErrorMsgDetail = {
  B_Srno: "",
  B_Itmcd: "",
  B_Barcode: "",
  B_ItmName: "",
  B_Qty: "",
  B_Unit: "",
  B_PackQty: "",
  SplDisc: "",
  B_URateFc: "",
  B_URateLc: "",
  B_GrossAmt: "",
  B_TDiscPerc: "",
  B_TDiscAmt: "",
  B_LDiscPerc: "",
  B_LDiscAmt: "",
  B_FocFlag: "",

  B_FocAmt: "",
  B_ExciseTaxAmt: "",
  B_ExciseTaxNetAmt: "",
  SplDiscAmt: "",
  B_Base_Rate: "",
  B_TaxDept: "",
  B_TaxPerc: "",
  B_TaxAmt: "",
  B_TaxDept2: "",
  B_TaxPerc2: "",
  B_TaxAmt2: "",
  B_NetAddCess: "",
  SplDiscPerc: "",
  B_NetAmt: "",
  AddCess: "",
};
export const vHeaderSearchInit = {
  AnyData: "",
  Name: "",
  Code: "",
};

export const sTrnTyp = "WMINV04";

const sFocFlagArr = [
  "",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "AA",
  "AB",
  "AC",
  "AD",
  "AE",
  "AF",
  "AG",
  "AH",
  "AJ",
  "AK",
  "AL",
  "AM",
  "AN",
  "AO",
  "AP",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AV",
  "AW",
  "AX",
  "AY",
  "AZ",
  "BA",
  "BB",
  "BC",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BJ",
  "BK",
  "BL",
  "BM",
  "BN",
  "BO",
  "BP",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BU",
  "BV",
  "BW",
  "BX",
  "BY",
  "BZ",
  "CA",
  "CB",
  "CC",
  "CD",
  "CE",
  "CF",
  "CG",
  "CH",
  "CJ",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CP",
  "CQ",
  "CR",
  "CS",
  "CT",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DA",
  "DB",
  "DC",
  "DD",
  "DE",
  "DF",
  "DG",
  "DH",
  "DJ",
  "DK",
  "DL",
  "DM",
  "DN",
  "DO",
  "DP",
  "DQ",
  "DR",
  "DS",
  "DT",
  "DU",
  "DV",
  "DW",
  "DX",
  "DY",
  "DZ",
];

export const xGC_Toggle_Head_Customer_DropDown_Arr = ["Any", "Code", "Name"];

export const ItemSearchData = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

export const locatonSearchData = ["Any", "Code", "Name"];
const sFrom = [
  { Uid: "VENDOR_INV", Name: "Vendor" },
  { Uid: "TRANSFER_RETURN", Name: "Outlet" },
  { Uid: "SALES_RETURN", Name: "Sales Return" },
];

const sPaymode = [
  { Uid: "CASH", Name: "Cash" },
  { Uid: "CREDIT", Name: "Credit" },
];

const sTax = [
  { Uid: "INTRN001", Name: "VAT" },
  { Uid: "INTRN002", Name: "Inter.Comp" },
  { Uid: "INTRN003", Name: "Import" },
];

const TypeArr = [
  { Uid: "", Name: "" },
  { Uid: "Linewise Rebate", Name: "Linewise Rebate" },
  { Uid: "Credit Note", Name: "Credit Note" },
];
export const sStatusArr = ["ENTER", "POST", "DELETE", "DRAFT", "CANCEL"];

const fKeyOutboundGRV = (event) => {
  // WmsOutboundGRVContent
  const form = document.getElementById("WmsOutboundGRVHead");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fKeyOutboundGRVContent = (event) => {
  // WmsOutboundGRVContent
  const form = document.getElementById("WmsOutboundGRVContent");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fValidationHead_Client = (
  vRdxHead,
  setErrorMsg,
  sFooterObj,
  vMediaQuery,
  fSummary
) => {
  let iRes = true;

  if (
    vRdxHead.A_VocTyp === "" ||
    vRdxHead.A_VocTyp === null ||
    vRdxHead.A_VocTyp === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_VocTyp: "VocTyp should not be empty",
    }));
    fAlertToast("INFO", "VocTyp should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_VocNo === "" ||
    vRdxHead.A_VocNo === null ||
    vRdxHead.A_VocNo === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_VocNo: "VocNo should not be empty" }));
    fAlertToast("INFO", "VocNo should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PostDt === "" ||
    vRdxHead.A_PostDt === null ||
    vRdxHead.A_PostDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PostDt: "PostDt should not be empty",
    }));
    fAlertToast("INFO", "PostDt should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_RefNo === "" ||
    vRdxHead.A_RefNo === null ||
    vRdxHead.A_RefNo === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_RefNo: "Text should not be empty" }));
    fAlertToast("INFO", "Text should not be empty");
    iRes = false;
  } else if (vRdxHead.A_RefNo.toUpperCase() === "POS") {
    setErrorMsg((obj) => ({ ...obj, A_RefNo: "Text should not be POS" }));
    fAlertToast("INFO", "Text should not be POS");
    iRes = false;
  } else if (vRdxHead.A_RefNo.toUpperCase() === "CREDIT") {
    setErrorMsg((obj) => ({ ...obj, A_RefNo: "Text should not be CREDIT" }));
    fAlertToast("INFO", "Text should not be CREDIT");
    iRes = false;
  }

  if (
    vRdxHead.A_RefDt === "" ||
    vRdxHead.A_RefDt === null ||
    vRdxHead.A_RefDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_RefDt: "Reference Date should not be Empty",
    }));
    fAlertToast("INFO", "Reference Date should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.UnloadingBay === "" ||
    vRdxHead.UnloadingBay === null ||
    vRdxHead.UnloadingBay === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      UnloadingBay: "Unloading should not be Empty",
    }));
    fAlertToast("INFO", "Unloading should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Type === "" ||
    vRdxHead.A_Type === null ||
    vRdxHead.A_Type === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_Type: "GRN Type should not be empty",
    }));
    fAlertToast("INFO", "GRN Type should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Loc === "" ||
    vRdxHead.A_Loc === null ||
    vRdxHead.A_Loc === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_Loc: "Location should not be Empty" }));
    fAlertToast("INFO", "Location should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Buyer === "" ||
    vRdxHead.A_Buyer === null ||
    vRdxHead.A_Buyer === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({ ...obj, A_Buyer: "Buyer should not be Empty" }));
    fAlertToast("INFO", "Buyer should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PayMode === "" ||
    vRdxHead.A_PayMode === null ||
    vRdxHead.A_PayMode === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PayMode: "PayMode should not be Empty",
    }));
    fAlertToast("INFO", "PayMode should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Party === "" ||
    vRdxHead.A_Party === null ||
    vRdxHead.A_Party === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PartyName: "Party should not be empty",
    }));
    fAlertToast("INFO", "Party should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PartyName === "" ||
    vRdxHead.A_PartyName === null ||
    vRdxHead.A_PartyName === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PartyName: "Party Name should not be empty",
    }));
    fAlertToast("INFO", "Party Name should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Curr === "" ||
    vRdxHead.A_Curr === null ||
    vRdxHead.A_Curr === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_Curr: "Curr should not be empty" }));
    fAlertToast("INFO", "Curr should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_ExRate === "" ||
    Number(vRdxHead.A_ExRate) === 0 ||
    vRdxHead.A_ExRate === null ||
    vRdxHead.A_ExRate === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_ExRate: "ExRate should not be empty",
    }));
    fAlertToast("INFO", "ExRate should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.TaxType === "" ||
    vRdxHead.TaxType === null ||
    vRdxHead.TaxType === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      TaxType: "Tax Type should not be Empty",
    }));
    fAlertToast("INFO", "Tax Type should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.offer === "" ||
    vRdxHead.offer === null ||
    vRdxHead.offer === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      offer: "Offer should not be Empty",
    }));
    fAlertToast("INFO", "Offer should not be Empty");
    iRes = false;
  }
  if (
    vRdxHead.A_CrAc === "" ||
    vRdxHead.A_CrAcName === "" ||
    vRdxHead.A_CrAc === null ||
    vRdxHead.A_CrAc === undefined ||
    vRdxHead.A_CrAcName === null ||
    vRdxHead.A_CrAcName === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({ ...obj, A_CrAc: "CrAc is Empty" }));
    fAlertToast("INFO", "CrAc is Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_DrAc === "" ||
    vRdxHead.A_DrAcName === "" ||
    vRdxHead.A_DrAc === null ||
    vRdxHead.A_DrAc === undefined ||
    vRdxHead.A_DrAcName === null ||
    vRdxHead.A_DrAcName === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({ ...obj, A_DrAc: "DrAc is Empty" }));
    fAlertToast("INFO", "DrAc is Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Type === "" ||
    vRdxHead.A_Type === null ||
    vRdxHead.A_Type === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_Type: "Type should not be Empty" }));
    fAlertToast("INFO", "Type should not be Empty");
    iRes = false;
  }

  if (sFooterObj.A_LandVal < 0) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      A_Rounding: "Transaction amount should be greater than zero",
    }));
    fAlertToast("INFO", "Transaction amount should be greater than zero");
    iRes = false;
  }

  return iRes;
};

export const UnitRateFlag = () => {
  const { DBKernObj } = KernCAConfig();
  const iShowField = DBKernObj.WMINV03_UNITRATE_VLDT?.Val === "N";
  if (iShowField) {
    return false;
  } else {
    return true;
  }
};
const fValidationDetail_Client = (
  vRdxHead,
  sBufferObj,
  setErrorMsgDetail,
  sDetailGridData
) => {
  let iRes = true;

  if (sBufferObj.B_Srno === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));
    fAlertToast("INFO", "Serial number should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_Itmcd === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    fAlertToast("INFO", "Item code should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_ItmName === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    fAlertToast("INFO", "Item name should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_Qty === "" || Number(sBufferObj.B_Qty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty: "Qty should not be zero",
    }));
    fAlertToast("INFO", "Qty should not be zero");
    iRes = false;
  }

  if (sBufferObj.B_Unit === "") {
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    fAlertToast("INFO", "Select unit");
    iRes = false;
  } else if (
    sBufferObj.B_PackQty === "" ||
    Number(sBufferObj.B_PackQty) === 0
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Unit: "Pack quantity should not be zero",
    }));
    fAlertToast("INFO", "Pack quantity should not be zero");
    iRes = false;
  }

  if (UnitRateFlag()) {
    if (Number(sBufferObj.B_URateFc) === 0 || sBufferObj.B_URateFc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_URateFc: "Unit rate[F.C] should not be Zero",
      }));
      fAlertToast("INFO", "Unit rate[F.C] should not be Zero");
      iRes = false;
    }

    if (Number(sBufferObj.B_URateLc) === 0 || sBufferObj.B_URateLc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_URateLc: "Unit rate[L.C] should not be Zero",
      }));
      fAlertToast("INFO", "Unit rate[L.C] should not be Zero");
      iRes = false;
    }

    if (sBufferObj.B_GrossAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_GrossAmt: "GrossAmt should not be Empty",
      }));
      fAlertToast("INFO", "GrossAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_TDiscPerc === "" || sBufferObj.B_TDiscAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TDiscPerc: "TDiscPerc should not be Empty",
      }));
      fAlertToast("INFO", "TDiscPerc should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_LDiscPerc === "" || sBufferObj.B_LDiscAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "Line discount.% should not be empty",
      }));
      fAlertToast("INFO", "Line discount.% should not be empty");
      iRes = false;
    }

    if (
      (Number(sBufferObj.B_LDiscPerc) === 0 &&
        Number(sBufferObj.B_LDiscAmt) !== 0) ||
      (Number(sBufferObj.B_LDiscPerc) !== 0 &&
        Number(sBufferObj.B_LDiscAmt) === 0)
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "Line Disc.% or amount should be Zero",
      }));
      fAlertToast("INFO", "Line Disc.% or amount should be Zero");
      iRes = false;
    } else if (
      Number(sBufferObj.B_LDiscPerc) > 100 ||
      Number(sBufferObj.B_LDiscPerc) < 0
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc:
          "DiscPerc Percentage must be greater than 0 and less than or equal to 100",
      }));
      fAlertToast(
        "INFO",
        "DiscPerc Percentage must be greater than 0 and less than or equal to 100"
      );
      iRes = false;
    }

    if (sBufferObj.B_FocAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_FocAmt: "FocAmt should not be Empty",
      }));
      fAlertToast("INFO", "FocAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_ExciseTaxAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ExciseTaxAmt: "ExciseTaxAmt should not be Empty",
      }));
      fAlertToast("INFO", "ExciseTaxAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_ExciseTaxNetAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ExciseTaxNetAmt: "ExciseTaxNetAmt should not be Empty",
      }));
      fAlertToast("INFO", "ExciseTaxNetAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.SplDisc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        SplDisc: "SplDiscAmt should not be Empty",
      }));
      fAlertToast("INFO", "SplDiscAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxDept === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxDept: "TaxDept is Empty" }));
      fAlertToast("INFO", "TaxDept is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxPerc === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxPerc: "TaxPerc is Empty" }));
      fAlertToast("INFO", "TaxPerc is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxAmt === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxAmt: "TaxAmt is Empty" }));
      fAlertToast("INFO", "TaxAmt is Empty");
      iRes = false;
    }
    if (sBufferObj.B_TaxDept2 === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxDept2: "TaxDept2 is Empty" }));
      fAlertToast("INFO", "TaxDept2 is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxPerc2 === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxPerc2: "TaxPerc2 is Empty" }));
      fAlertToast("INFO", "TaxPerc2 is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxAmt2 === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxAmt2: "TaxAmt2 is Empty" }));
      fAlertToast("INFO", "TaxAmt2 is Empty");
      iRes = false;
    }

    if (sBufferObj.B_NetAddCess === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_NetAddCess: "B_NetAddCess is Empty",
      }));
      fAlertToast("INFO", "B_NetAddCess is Empty");
      iRes = false;
    }

    if (sBufferObj.SplDiscPerc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        SplDiscPerc: "SplDiscPerc is Empty",
      }));
      fAlertToast("INFO", "SplDiscPerc is Empty");
      iRes = false;
    }

    if (sBufferObj.B_NetAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_NetAmt: "B_NetAmt is Empty",
      }));
      fAlertToast("INFO", "B_NetAmt is Empty");
      iRes = false;
    }
  }

  return iRes;
};

//GCItemSearch
const GetItemSearch = async (
  xValue,
  xVendor,
  setGridSelectRowData,
  setGridSelectRowArr
) => {
  //openCustomer to call api on open modal if value in any data

  let sItemSearch = {
    v_AnyData: xValue,
    v_ItmCd: "",
    v_ItmName: "",
    v_Barcode: "",
    v_ModelSelectedValue: "",
    v_RefNo1: "",
    v_NameFc: "",
    v_CostPr: "",
    v_RSP: "",
    v_Catalogue: "",
    v_Br: "",
    v_RefNo3: "",
    v_Loc: "",
    v_Vendor: xVendor,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(sItemSearch);
  const vItemSearch = await fExecuteAPI("GRN_ITEMSEARCH_GETROW", FinalObj);
  if (vItemSearch.Status === 200) {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setGridSelectRowArr(vItemSearchArr);
    setGridSelectRowData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.Type.response.data.message
        ? vItemSearch.Type.response.data.message
        : "Error in ItemSearch"
    );
    return [];
  }
};

//TODO FULLSEARCH ,UNITARR ,AND CALCULATION
const fItemCodeDependency = async (
  vItemSearchFull,
  vRdxWmsHead,
  sBufferObj,
  setBufferObj,
  setUnit,
  sDefZeroTaxCode,
  sDefZeroCessCode,
  setItemStock
) => {
  const { HeadObject } = OutboundGRV();
  const { tax1, tax2 } = vRdxtax();
  if (vItemSearchFull.length > 0) {
    let iTax =
      HeadObject.TaxType == sTax[1].Uid || HeadObject.TaxType == sTax[2].Uid
        ? sDefZeroTaxCode
        : vItemSearchFull[0].TaxDept;

    let iCess =
      HeadObject.TaxType == sTax[1].Uid || HeadObject.TaxType == sTax[2].Uid
        ? sDefZeroCessCode
        : vItemSearchFull[0].TaxDept2;

    let vRdxGRNtax1arr = tax1?.find((obj) => {
      return obj.UId === iTax;
    });

    let vRdxGRNtax2arr = tax2?.find((obj) => {
      return obj.UId === iCess;
    });

    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
      B_Barcode: vItemSearchFull[0].BarCode,
      B_TaxDept: vRdxGRNtax1arr?.UId,
      B_TaxDept2: vRdxGRNtax2arr?.UId,
      B_TaxPerc: vRdxGRNtax1arr?.Perc,
      B_TaxPerc2: vRdxGRNtax2arr?.Perc,
    }));

    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    let iUnit = vItemSearchFull[0]?.DefUnit || "";

    if (!iUnit) {
      iUnit = vItemSearchFull[0]?.PurUOM || "";
    }

    let vItemUnitSet = currentUnitArr.find((obj) => {
      return obj.Unit === iUnit;
    });

    if (!vItemUnitSet) {
      iUnit = currentUnitArr[0]?.Unit || "";

      vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === iUnit;
      });
    }
    await Unit_Onchange_001(
      iUnit,
      vItemUnitSet,
      vItemSearchFull[0]?.ItmCd,
      vRdxGRNtax1arr?.Perc,
      vRdxGRNtax2arr?.Perc,
      setBufferObj,
      sBufferObj,
      setItemStock
    );

    document.getElementsByName("B_Qty")[0]?.focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

export const Unit_Onchange_001 = async (
  xUnit = "",
  xUnitObj = {},
  xItemCode = "",
  iTax1Perc = "",
  iTax2Perc = "",
  setBufferObj = () => {},
  sBufferObj = {},
  setItemStock
) => {
  const { HeadObject } = OutboundGRV();
  //by sir
  if (!!xUnitObj) {
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: xUnitObj.Unit,
      B_UnitName: xUnitObj.Name1,
      B_PackQty: xUnitObj.PackQty,
    }));
  }

  let currentUnitRateArr = await GetUnitRateArr(
    xItemCode,
    xUnit,
    HeadObject?.A_Party,
    HeadObject?.A_Loc,
    "", // vRdxWmsHead?.A_RefDocTyp,
    "" //vRdxWmsHead?.A_RefDocNo
  );

  let currentUnitRateObj = {
    B_URateFc: 0,
    B_LDiscPerc: 0,
    AddCess: 0,
    SplDiscAmt: 0,
    B_ExciseTaxAmt: 0,
  };

  if (currentUnitRateArr.length > 0) {
    currentUnitRateObj = {
      B_URateFc: currentUnitRateArr[0].CostLc,
      B_LDiscPerc: currentUnitRateArr[0].DiscPerc,
      AddCess: currentUnitRateArr[0].AddiCess,
      SplDisc: currentUnitRateArr[0].SplDiscAmt,
      B_ExciseTaxAmt: currentUnitRateArr[0].ExciseAmt,
    };
    setBufferObj((obj) => ({
      ...obj,
      B_URateFc: currentUnitRateArr[0].CostLc,
      B_LDiscPerc: currentUnitRateArr[0].DiscPerc,
      AddCess: currentUnitRateArr[0].AddiCess,
      SplDisc: currentUnitRateArr[0].SplDiscAmt, //by sir
      B_ExciseTaxAmt: currentUnitRateArr[0].ExciseAmt,
    }));
  }
  GetItemStock(
    xItemCode,
    sBufferObj.B_Srno,
    HeadObject.A_Loc,
    setItemStock,
    xUnitObj.PackQty
  );
  let {
    B_BaseQty,
    B_URateLc,
    B_GrossAmt,
    B_LDiscAmt,
    B_TDiscAmt,
    B_FocAmt,
    B_ExciseTaxNetAmt,
    B_NetAmt,
    B_TaxAmt,
    B_TaxAmt2,
    B_Rounding,
    B_NetAddCess,
    B_LandVal,
  } = fCalculate_Detail(
    sBufferObj.B_Qty,
    xUnitObj.PackQty,
    HeadObject.A_ExRate,
    currentUnitRateObj.B_URateFc,
    currentUnitRateObj.B_LDiscPerc,
    sBufferObj.B_TDiscPerc,
    sBufferObj.B_FocFlag,
    currentUnitRateObj.B_ExciseTaxAmt,
    iTax1Perc,
    iTax2Perc,
    currentUnitRateObj.AddCess,
    0
  );
  setBufferObj((obj) => ({
    ...obj,
    B_BaseQty,
    B_URateLc,
    B_GrossAmt,
    B_LDiscAmt,
    B_TDiscAmt,
    B_FocAmt,
    B_ExciseTaxNetAmt,
    B_NetAmt,
    B_TaxAmt,
    B_TaxAmt2,
    B_Rounding,
    B_NetAddCess,
    B_LandVal,
  }));
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  const { HeadObject } = OutboundGRV();
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
    v_Vendor: HeadObject.A_Party || "",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch.Type == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};

const fLoad_Grid = async (
  xB_VocNo,
  xB_Srno,
  xRoundingValue = "",
  setDetailGridData,
  setFooterObj,
  xVocTyp
) => {
  const iSIDetail = await GetSIDetail(xB_VocNo, xB_Srno, xVocTyp);

  if (!!iSIDetail?.length && iSIDetail?.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
    var iGrossAmt = 0,
      iTDiscAmt = 0,
      iLDiscAmt = 0,
      iFocAmt = 0,
      iExciseTaxNetAmt = 0,
      iTaxAmt = 0,
      iTaxAmt2 = 0,
      iAddCess = 0,
      iSplDiscAmt1 = 0;

    for (let i = 0; i < iSIDetail?.length; i++) {
      iGrossAmt += iSIDetail[i]?.B_GrossAmt;
      iTDiscAmt += iSIDetail[i]?.B_TDiscAmt;
      iLDiscAmt += iSIDetail[i]?.B_LDiscAmt;
      iFocAmt += 0; //iSIDetail[i].B_FocAmt;
      iExciseTaxNetAmt += iSIDetail[i]?.B_ExciseTaxNetAmt;
      iTaxAmt += iSIDetail[i]?.B_TaxAmt;
      iTaxAmt2 += iSIDetail[i]?.B_TaxAmt2;
      iAddCess += iSIDetail[i]?.B_NetAddCess;
      iSplDiscAmt1 += iSIDetail[i]?.SplDiscAmt1;
    }

    let iLandVal =
      iGrossAmt -
      iTDiscAmt -
      iLDiscAmt -
      iFocAmt +
      iExciseTaxNetAmt +
      iTaxAmt +
      iTaxAmt2 +
      iAddCess +
      iSplDiscAmt1 +
      fcovertToNumber(xRoundingValue);

    setFooterObj((obj) => ({
      ...obj,
      A_GrossAmt: iGrossAmt.toFixed(2),
      A_TDiscAmt: iTDiscAmt.toFixed(2),
      A_LDiscAmt: iLDiscAmt.toFixed(2),
      A_FocAmt: iFocAmt.toFixed(2),
      A_NetExcise: iExciseTaxNetAmt.toFixed(2),
      A_Tax: iTaxAmt.toFixed(2),
      A_Tax2: iTaxAmt2.toFixed(2),
      A_AddCess: iAddCess.toFixed(2),
      A_LandVal: iLandVal.toFixed(2),
      A_SplDiscAmt1: iSplDiscAmt1.toFixed(2),
    }));
  } else {
    setDetailGridData([]);
    setFooterObj((obj) => ({
      ...obj,
      A_GrossAmt: 0,
      A_TDiscAmt: 0,
      A_LDiscAmt: 0,
      A_FocAmt: 0,
      A_NetExcise: 0,
      A_Tax: 0,
      A_Tax2: 0,
      A_AddCess: 0,
      A_LandVal: 0,
      A_SplDiscAmt1: 0,
    }));
  }
};

//Reverse Modal
const fCloseReverseTransactionModal = (setReverseTransactionModal) => {
  setReverseTransactionModal(false);
};

const fOpenReverseTransactionModal = (setReverseTransactionModal) => {
  setReverseTransactionModal(true);
};

const fReverse = (fSave, setRevNarr, setReverseTransactionModal) => {
  fCloseReverseTransactionModal(setReverseTransactionModal);
  confirmAlert({
    title: "Reverse",
    message: "Are you sure to Reverse.",
    buttons: [
      {
        className: "alertBtn",
        label: "Yes",
        onClick: () => fSave(),
      },
      {
        className: "alertBtn",
        label: "No",
        onClick: () => setRevNarr(""),
      },
    ],
  });
};

const fDefaultPayload = (xPaymode, dispatch) => {
  let iPaymode = xPaymode == "BOTH" ? "CREDIT" : xPaymode; //by client
  let DefaultPayload = {
    currentPayMode: iPaymode,
    PaymodeEnable: false,
  };
  if (xPaymode == "BOTH") {
    DefaultPayload.PaymodeEnable = false;
  } else {
    DefaultPayload.PaymodeEnable = true;
  }

  dispatch(
    Set_OutboundGRV_HeadObject_A_PayMode({
      A_PayMode: iPaymode,
    })
  );
  return DefaultPayload;
};

//HEAD LOADING API
// Api

// Checkbox_Rights_GETROW
const GetCheckboxUserRights = async (dispatch) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const vCheckBoxRightsObj = {
    usercd: vRdxUserInfoObj.UserID,
    usergrp: vRdxUserInfoObj.UserGroupCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vCheckBoxRightsObj);
  const vCheckBoxRights = await fExecuteAPI(
    "Checkbox_User_Rights_GETROW",
    FinalObj
  );
  if (vCheckBoxRights?.Type?.toUpperCase() === "SUCCESS") {
    return vCheckBoxRights?.ResultSet;
  } else {
    fAlertToast(
      "FAILED",
      vCheckBoxRights?.response?.data?.message
        ? vCheckBoxRights?.response?.data?.message
        : "Error in CheckBoxRights"
    );
    return [];
  }
};

//GET_API_Buyer
const GetBuyer = async (xloc, xvocTyp, xvocNo, dispatch) => {
  let iBuyerObj = {
    loc: xloc,
    trnTyp: sTrnTyp,
    vocTyp: xvocTyp,
    vocNo: xvocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iBuyerObj);
  const iBuyer = await fExecuteAPI("GRN_BUYER_GETROW_001", FinalObj);

  if (iBuyer?.Type?.toUpperCase() === "SUCCESS") {
    return iBuyer.ResultSet.length > 0 ? iBuyer.ResultSet : [];
  } else {
    fAlertToast(
      "FAILED",
      iBuyer.response.data.Status
        ? iBuyer.response.data.Status
        : "Error in Currency"
    );
    return [];
  }
};
//SALESMAN_GETROW
const GetSalesman = async (dispatch) => {
  const iSalesman = await fExecuteAPI("SALESMAN_GETROW");
  if (iSalesman?.Type?.toUpperCase() === "SUCCESS") {
    return iSalesman.ResultSet.length > 0 ? iSalesman.ResultSet : [];
  } else {
    fAlertToast(
      "FAILED",
      iSalesman.response.data.Status
        ? iSalesman.response.data.Status
        : "Error in Currency"
    );
    return [];
  }
};

//API DEFAULTDRCRACCOUNT_GETROW
const GetDefaultDrCrAccount = async (xVocTyp, xPayMode, xParty, dispatch) => {
  let vDefaultDrCrAccountObj = {
    process: sTrnTyp,
    voucher: xVocTyp,
    paymode: xPayMode,
    party: xParty,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vDefaultDrCrAccountObj);
  const vDefaultDrCrAccount = await fExecuteAPI(
    "DEFAULTDRCRACCOUNT_GETROW",
    FinalObj
  );
  if (vDefaultDrCrAccount?.Type?.toUpperCase() === "SUCCESS") {
    if (vDefaultDrCrAccount?.ResultSet?.length > 0) {
      dispatch(
        Set_OutboundGRV_HeadObject_DrCrAccount({
          A_CrAc: !!vDefaultDrCrAccount.ResultSet[0]?.CrAc
            ? vDefaultDrCrAccount.ResultSet[0]?.CrAc
            : "",
          A_CrAcName: !!vDefaultDrCrAccount.ResultSet[0]?.CrAcName
            ? vDefaultDrCrAccount.ResultSet[0]?.CrAcName
            : "",
          A_DrAc: vDefaultDrCrAccount.ResultSet[0]?.DrAc,
          A_DrAcName: vDefaultDrCrAccount.ResultSet[0]?.DrAcName,
        })
      );
    }
  } else {
    fAlertToast("FAILED", vDefaultDrCrAccount.Message);
  }
};

//API SALESHISTORY_GETROW
const GetSalesHistory = async (
  xItmcd,
  xUnit,
  xParty,
  xLoc,
  setGridSalesHistoryRowData
) => {
  let vSalesHistoryObj = {
    itmCd: xItmcd,
    party: xParty,
    unit: xUnit,
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSalesHistoryObj);

  const vSalesHistory = await fExecuteAPI(
    "WMINV04_salesHistory_GETROW",
    FinalObj
  );
  if (vSalesHistory?.Type?.toUpperCase() === "SUCCESS") {
    let vSalesHistoryResp = vSalesHistory.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
      // A_PostDt: moment(obj.A_PostDt).format("DD/MM/YYYY"),
    }));
    setGridSalesHistoryRowData(vSalesHistoryResp);
    return vSalesHistory.ResultSet.length > 0 ? vSalesHistoryResp : [];
  } else {
    fAlertToast("FAILED", vSalesHistory.Message);
    return [];
  }
};

//API GRN_LOCATIONSEARCH_GETROW
const GetLocation = async (
  xAnyData,
  xCode,
  xName,
  UserID,
  setHeaderSearchResultArr,
  setHeaderSearchResultData
) => {
  let vHeaderSearchObj = {
    v_AnyData: xAnyData,
    v_Cd: xCode,
    v_Distri: "Y",
    v_Name: xName,
    v_UserCd: UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vHeaderSearchObj);

  const vHeaderSearch = await fExecuteAPI(
    "GRN_LOCATIONSEARCH_GETROW",
    FinalObj
  );
  if (vHeaderSearch.Status === 200) {
    let GridID = vHeaderSearch.ResultSet?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setHeaderSearchResultArr(GridID);
    setHeaderSearchResultData(GridID);
    return GridID;
  } else {
    fAlertToast(
      "FAILED",
      vHeaderSearch.response.data.Status
        ? vHeaderSearch.response.data.Status
        : "Error in loading SrcDoc"
    );
    return [];
  }
};

//API Unit GETITEMUNITSINBOUND_GETROW
const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("GETITEMUNITSINBOUND_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
    return [];
  }
};

const GetIncentiveGroup = async (xB_Itmcd, xA_Loc, SetIncentiveGroups) => {
  let vIncentiveGroupsObj = {
    itemCd: xB_Itmcd,
    loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vIncentiveGroupsObj);

  const vIncentiveGroups = await fExecuteAPI("INCENTIVEGROUP_GETROW", FinalObj);
  if (vIncentiveGroups.Type === "SUCCESS") {
    if (vIncentiveGroups.ResultSet.length > 0) {
      SetIncentiveGroups(vIncentiveGroups.ResultSet);
      return vIncentiveGroups.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vIncentiveGroups.Type.response.data.message
        ? vIncentiveGroups.Type.response.data.message
        : "Error in vIncentiveGroups"
    );
    return [];
  }
};
const GetSupervisorSlabs = async (xsetSupervisorSlabs) => {
  const vSupervisorSlabs = await fExecuteAPI("SUPERVISORSLABS_GETROW");
  if (vSupervisorSlabs?.Type?.toUpperCase() === "SUCCESS") {
    xsetSupervisorSlabs(vSupervisorSlabs.ResultSet);
    return vSupervisorSlabs.ResultSet;
  } else {
    fAlertToast("FAILED", vSupervisorSlabs.Message);
    return [];
  }
};

const GetOtherSlabs = async (setOtherSlabs) => {
  const vOtherSlabs = await fExecuteAPI("OTHERSLABS_GETROW");
  if (vOtherSlabs?.Type?.toUpperCase() === "SUCCESS") {
    setOtherSlabs(vOtherSlabs.ResultSet);
    return vOtherSlabs.ResultSet;
  } else {
    fAlertToast("FAILED", vOtherSlabs.Message);
    return [];
  }
};

//API  ITEM_LINE_GETROW
const GetItemLineArr = async (xItemCode, xLoc, xParty, setItemLine) => {
  let vItemLineObj = {
    v_ItemCd: xItemCode,
    v_Loc: xLoc,
    v_Vendor: xParty,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemLineObj);

  const ItemLineInfo = await fExecuteAPI("ITEM_LINE_GETROW", FinalObj);
  if (ItemLineInfo.Status === 200) {
    if (ItemLineInfo.ResultSet.length > 0) {
      setItemLine(ItemLineInfo.ResultSet);
      return ItemLineInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      ItemLineInfo.Type.response.data.message
        ? ItemLineInfo.Type.response.data.message
        : "Error in ItemLineArr"
    );
    return [];
  }
};

//API  UNIT_RATE_GETROW
const GetUnitRateArr = async (
  xItmCd,
  xUnitId,
  xParty,
  xLoc,
  xVocTyp,
  xVocNo
) => {
  let vUnitRateObj = {
    ItmCd: xItmCd,
    UnitId: xUnitId,
    Party: xParty,
    Loc: xLoc,
    VocTyp: xVocTyp,
    VocNo: xVocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vUnitRateObj);

  const UnitRateInfo = await fExecuteAPI("INBOUNDUNITRATE_GETROW", FinalObj);
  if (UnitRateInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitRateInfo.ResultSet.length > 0) {
      return UnitRateInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitRateInfo.Type.response.data.message
        ? UnitRateInfo.Type.response.data.message
        : "Error in UnitRateArr"
    );
    return [];
  }
};

//API
const GetItemFullSearchArr = async (xItemName, xLoc) => {
  // let vItemFullSearchDataObj = {
  //   v_AnyData: xItemName,
  //   v_TransType: "F",
  //   v_Report: "Y",
  // };
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    FinalObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull.Type.response.data.message
        ? vItemSearchFull.Type.response.data.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

//API GETSIDETAILS_GETROW
const GetSIDetail = async (xB_VocNo, xB_Srno, xVocTyp) => {
  let iSIDetailObj = {
    VocTyp: !!xVocTyp ? xVocTyp : "",
    VocNo: !!xB_VocNo ? xB_VocNo : "",
    SrNo: xB_Srno,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const iSIDetailResult = await fExecuteAPI(
    "WMINV04_getDetails_GETROW",
    FinalObj
  );
  if (iSIDetailResult?.Type?.toUpperCase() === "SUCCESS") {
    if (iSIDetailResult.ResultSet.length > 0) {
      return iSIDetailResult.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      iSIDetailResult.response.data.message
        ? iSIDetailResult.response.data.message
        : iSIDetailResult.response.data.Status
    );
  }
};

//API GETITEMATTRIBUTES_GETROW
const fValidateItemsAttributes = async (sBufferObj, setErrorMsgDetail) => {
  const { HeadObject } = OutboundGRV();
  const vRdxUserInfoObj = vRdxUserInfo();
  let vItemAttributesObj = {
    itmCd: sBufferObj.B_Itmcd,
    loc: HeadObject.A_Loc,
    taxType: HeadObject.TaxType,
    unit: sBufferObj.B_Unit,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemAttributesObj);
  const vItemAttributes = await fExecuteAPI(
    "GETITEMATTRIBUTES_GETROW",
    FinalObj
  );

  if (
    vItemAttributes?.Type?.toUpperCase() === "SUCCESS" &&
    vItemAttributes.ResultSet.length > 0
  ) {
    let vGetItemAttributes = vItemAttributes.ResultSet[0];
    let iRes = true;

    if (vGetItemAttributes.Linking != "") {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_Itmcd: vGetItemAttributes.Linking,
      }));
      iRes = false;
    }

    if (vGetItemAttributes.ItmActive == "N") {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_ItmName: "Item is in-actived",
      }));
      iRes = false;
    }

    // if (vGetItemAttributes.Stock - sBufferObj.B_BaseQty < 0) {
    //     fAlertToast("FAILED", "Qty exceed than Available stock " + vGetItemAttributes.Stock.toFixed(2));
    //     iRes = false
    // }

    if (vGetItemAttributes.TaxDept1 != sBufferObj.B_TaxDept) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxDept: "Tax code is not matching",
      }));
      iRes = false;
    }

    if (vGetItemAttributes.TaxPerc1 != sBufferObj.B_TaxPerc) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxPerc: "Tax % is not matching",
      }));
      iRes = false;
    }

    if (vGetItemAttributes.TaxDept2 != sBufferObj.B_TaxDept2) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxDept2: "Cess code is not matching",
      }));
      iRes = false;
    }

    if (vGetItemAttributes.TaxPerc2 != sBufferObj.B_TaxPerc2) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxPerc2: "Cess % is not matching",
      }));
      iRes = false;
    }

    return { iRes, vGetItemAttributes };
  } else {
    fAlertToast("FAILED", "GETITEMATTRIBUTES_GETROW");
  }
};

//API VALIDATIONDETAILINFO_GETROW
const fGetValidationDetailInfo = async (
  sBufferObj,
  ErrorMsgDetail,
  setErrorMsgDetail
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = OutboundGRV();

  let vResp = true;
  let vValidationDetailInfoObj = {
    trnTyp: sTrnTyp,
    vocTyp: HeadObject.A_VocTyp,
    vocNo: HeadObject.A_VocNo,
    B_Srno: sBufferObj.B_Srno,
    userCd: vRdxUserInfoObj.UserID,
    B_Itmcd: sBufferObj.B_Itmcd,
    unit: sBufferObj.B_Unit,
    A_Loc: HeadObject.A_Loc,
    landAmt: sBufferObj.B_LandVal,
    B_Qty: sBufferObj.B_Qty,
    refDoctyp: "", //HeadObject.A_RefDocTyp,
    refDocName: "", //HeadObject.A_RefDocTypName,
    refDocNo: HeadObject.A_RefNo,
    party: HeadObject.A_Party,
    B_BaseQty: sBufferObj.B_BaseQty,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vValidationDetailInfoObj);
  const vValidationDetailInfo = await fExecuteAPI(
    "WMINV04_validateDetail_GETROW",
    FinalObj
  );
  if (vValidationDetailInfo.Type == "SUCCESS") {
    vResp = true;
  } else {
    if (vValidationDetailInfo.Type == "SUCCESS") {
      vResp = true;
    } else if (vValidationDetailInfo.response.status == 400) {
      let isKeyAvailable =
        vValidationDetailInfo.response.data.ResultSet.field in ErrorMsgDetail;
      if (isKeyAvailable) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          [vValidationDetailInfo.response.data.ResultSet.field]:
            vValidationDetailInfo.response.data.Status,
        }));
      } else {
        if (vValidationDetailInfo.response.data.Status) {
          fAlertToast("FAILED", vValidationDetailInfo.response.data.Status);
        } else {
          fAlertToast("FAILED", "vValidationDetailInfo.response.data.Status");
        }
      }
      return (vResp = false);
    } else if (vValidationDetailInfo.response.status == 500) {
      fAlertToast("FAILED", vValidationDetailInfo.response.data.Status);
      return (vResp = false);
    }
    return (vResp = false);
  }
  return vResp;
};

const fSaveHead_Detsil = async (
  xSave,
  setUser_Doc_Arr,
  sUser_Doc_Arr,
  dispatch,
  fNewDetail,
  sBufferObj,
  setBuyer,
  xDocStatus
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = OutboundGRV();
  const iStatus = xSave ? HeadObject.A_DocStat : xDocStatus; //xSave False means Post
  let vSaveSIHeadObj = {
    // Header
    v_A_VocTyp: HeadObject.A_VocTyp,
    v_A_VocNo: HeadObject.A_VocNo,
    v_A_VocDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    v_A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    v_A_RefDt: moment(HeadObject.A_RefDt).format("MM/DD/YYYY"),
    v_A_RefNo: HeadObject.A_RefNo,
    v_A_Party: HeadObject.A_Party,
    v_A_Curr: HeadObject.A_Curr,
    v_A_ExRate: HeadObject.A_ExRate,
    v_A_PayMode: HeadObject.A_PayMode,
    v_A_Type: HeadObject.A_Type,
    v_A_Loc: HeadObject.A_Loc,
    v_A_Buyer: HeadObject.A_Buyer,
    v_A_Narr: HeadObject.A_Narr,
    v_A_CrAc: HeadObject.A_CrAc,
    v_A_DrAc: HeadObject.A_DrAc,
    v_A_GrossAmt: 0,
    v_A_DiscPerc: HeadObject.A_DiscPerc,
    v_A_DiscAmt: HeadObject.A_DiscAmt,
    v_A_Rounding: HeadObject.A_Rounding,
    v_A_DocStat: iStatus,
    v_IP: vRdxUserInfoObj.IP,
    v_UserId: vRdxUserInfoObj.UserID,
    v_A_Taxable: HeadObject.A_Taxable,
    v_A_TAX_TYPE: HeadObject.TaxType,
    v_A_UnloadBin: HeadObject.UnloadingBay,
    v_A_OFFER_TRANS: HeadObject.offer,

    // Detail
    v_B_Srno: sBufferObj.B_Srno,
    v_B_Itmcd: sBufferObj.B_Itmcd,
    v_B_Qty: sBufferObj.B_Qty,
    v_B_Unit: sBufferObj.B_Unit,
    v_B_URateFc: sBufferObj.B_URateFc,
    v_B_URateLc: sBufferObj.B_URateLc,
    v_B_GrossAmt: sBufferObj.B_GrossAmt,
    v_B_LDiscPerc: sBufferObj.B_LDiscPerc,
    v_B_LDiscAmt: sBufferObj.B_LDiscAmt,
    v_B_NetAmt: sBufferObj.B_NetAmt,
    v_B_LandVal: sBufferObj.B_LandVal,
    v_B_BaseQty: sBufferObj.B_BaseQty,
    v_B_RefDocTyp: sBufferObj.B_RefDocTyp,
    v_B_RefDocNo: sBufferObj.B_RefDocNo,
    v_B_ExciseTaxAmt: sBufferObj.B_ExciseTaxAmt,
    v_B_ExciseTaxNetAmt: sBufferObj.B_ExciseTaxNetAmt,
    v_B_TaxPerc: sBufferObj.B_TaxPerc,
    v_B_TaxAmt: sBufferObj.B_TaxAmt,
    v_SplDiscAmt1: sBufferObj.SplDisc,
    v_TaxDept: sBufferObj.B_TaxDept,
    v_B_TaxDept2: sBufferObj.B_TaxDept2,
    v_B_TaxPerc2: sBufferObj.B_TaxPerc2,
    v_B_TaxAmt2: sBufferObj.B_TaxAmt2,
    v_B_Ad_CessAmt: 0,
    v_B_Ad_PCQty: 0,
    v_B_Ad_PCRate: sBufferObj.AddCess,
    v_B_Ad_NetCessAmt: sBufferObj.B_NetAddCess,
    v_Result: "Y",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);

  const vSaveSIHead = await SaveWMINV04_GETROW(FinalObj);
  if (vSaveSIHead?.status === 200) {
    let iVocNo = xSave
      ? vSaveSIHead?.data?.ResultSet?.DocNo
      : HeadObject.A_VocNo;
    if (HeadObject.A_VocNo == "0") {
      setUser_Doc_Arr([
        ...sUser_Doc_Arr,
        {
          A_VocTyp: HeadObject.A_VocTyp,
          A_VocNo: iVocNo,
          SrNo: sUser_Doc_Arr.length + 1,
        },
      ]);
    }

    dispatch(
      Set_OutboundGRV_HeadObject_A_VocNo({
        A_VocNo: iVocNo,
        A_DocStat: iStatus,
      })
    );

    //approve bool type false
    if (!xSave) {
      fDisplay(HeadObject.A_VocTyp, iVocNo, dispatch, fNewDetail, setBuyer);

      fAlertToast("SUCCESS", "Successfully posted");
    } else {
      fAlertToast("SUCCESS", "Successfully Saved");
      fNewDetail(
        iVocNo,
        HeadObject.A_Rounding,
        HeadObject?.A_VocTyp,
        HeadObject?.TaxType
      );
    }
  }
};
//API SaveSIHead
const fSaveHead = async (
  xSave,
  setUser_Doc_Arr,
  sUser_Doc_Arr,
  dispatch,
  fNewDetail,
  sBufferObj,
  setBuyer,
  xDocStatus
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = OutboundGRV();
  const iStatus = xSave ? HeadObject.A_DocStat : xDocStatus; //xSave False means Post
  let vSaveSIHeadObj = {
    A_VocTyp: HeadObject.A_VocTyp,
    A_VocNo: HeadObject?.A_VocNo,
    A_VocDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    A_RefDt: moment(HeadObject.A_RefDt).format("MM/DD/YYYY"),
    A_RefNo: HeadObject.A_RefNo,
    A_Party: HeadObject.A_Party,
    A_Curr: HeadObject.A_Curr,
    A_ExRate: HeadObject.A_ExRate,
    A_PayMode: HeadObject.A_PayMode,
    A_Type: HeadObject.A_Type,
    A_Loc: HeadObject.A_Loc,
    A_Buyer: HeadObject.A_Buyer,
    A_Narr: HeadObject.A_Narr,
    A_CrAc: HeadObject.A_CrAc,
    A_DrAc: HeadObject.A_DrAc,
    A_GrossAmt: 0,
    A_DiscPerc: HeadObject?.A_DiscPerc,
    A_DiscAmt: HeadObject?.A_DiscAmt,
    A_Rounding: HeadObject?.A_Rounding,
    A_DocStat: iStatus,
    IP: vRdxUserInfoObj.IP,
    UserId: vRdxUserInfoObj.UserID,
    A_Taxable: HeadObject.A_Taxable,
    A_TAX_TYPE: HeadObject.TaxType,
    A_UnloadBin: HeadObject.UnloadingBay,
    A_OFFER_TRANS: HeadObject.offer,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);

  const vSaveSIHead = await fExecuteAPI("WMINV04_saveHead_GETROW", FinalObj);
  if (vSaveSIHead.Type == "SUCCESS") {
    if (HeadObject.A_VocNo == "0") {
      setUser_Doc_Arr([
        ...sUser_Doc_Arr,
        {
          A_VocTyp: HeadObject.A_VocTyp,
          A_VocNo: vSaveSIHead?.ResultSet[0]?.A_VocNo,
          SrNo: sUser_Doc_Arr.length + 1,
        },
      ]);
    }

    dispatch(
      Set_OutboundGRV_HeadObject_A_VocNo({
        A_VocNo: xSave
          ? vSaveSIHead?.ResultSet[0]?.A_VocNo
          : HeadObject.A_VocNo,
        A_DocStat: iStatus,
      })
    );

    //approve bool type false
    if (!xSave) {
      fDisplay(
        HeadObject.A_VocTyp,
        xSave ? vSaveSIHead?.ResultSet[0]?.A_VocNo : HeadObject.A_VocNo,
        dispatch,
        fNewDetail,
        setBuyer
      );

      fAlertToast("SUCCESS", "Successfully posted");
    } else {
      fSaveDetail(vSaveSIHead.ResultSet[0].A_VocNo, sBufferObj, fNewDetail);
    }
  } else {
    fAlertToast(
      "FAILED",
      !!vSaveSIHead.response.data.Status
        ? vSaveSIHead?.response?.data?.Status
        : "Fail to Save Head"
    );
  }
};

//API GETSIHEAD_GETROW to gethead
const fDisplay = async (xA_VocTyp, A_VocNo, dispatch, fNewDetail, setBuyer) => {
  const { HeadObject } = OutboundGRV();
  let vSIHeadObj = {
    A_VocTyp: xA_VocTyp,
    A_VocNo: A_VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSIHeadObj);
  const vSIHead = await fExecuteAPI("WMINV04_getHead_GETROW", FinalObj);
  if (vSIHead?.Type?.toUpperCase() === "SUCCESS") {
    dispatch(
      Set_WmsOutboundGRV_HeadObject_Set({
        ...HeadObject,
        A_VocTyp: vSIHead.ResultSet[0].A_VocTyp,
        A_VocTypName: vSIHead.ResultSet[0].VocName,
        A_VocNo: vSIHead.ResultSet[0].A_VocNo,
        A_PostDt: vSIHead.ResultSet[0].A_PostDt,
        A_RefDt: vSIHead.ResultSet[0].A_RefDt,
        A_RefNo: vSIHead.ResultSet[0].A_RefNo,
        A_Party: vSIHead.ResultSet[0].A_Party,
        A_PartyName: vSIHead.ResultSet[0].PartyName,
        A_Curr: vSIHead.ResultSet[0].A_Curr,
        A_Currname: vSIHead.ResultSet[0].CurrName,
        A_ExRate: vSIHead.ResultSet[0].A_ExRate,
        A_PayMode: vSIHead.ResultSet[0].A_PayMode,
        A_Type: vSIHead.ResultSet[0].A_Type,
        A_Loc: vSIHead.ResultSet[0].A_Loc,
        A_Buyer: vSIHead.ResultSet[0].A_Buyer, ////SalesMan
        A_Narr: vSIHead.ResultSet[0].A_Narr,
        A_CrAc: vSIHead.ResultSet[0].A_CrAc,
        A_CrAcName: vSIHead.ResultSet[0].CrAcName,
        A_DrAc: vSIHead.ResultSet[0].A_DrAc,
        A_DrAcName: vSIHead.ResultSet[0].DrAcName,
        A_DiscPerc: vSIHead.ResultSet[0].A_DiscPerc
          ? vSIHead.ResultSet[0].A_DiscPerc
          : 0,
        A_Rounding: vSIHead.ResultSet[0].A_Rounding
          ? vSIHead.ResultSet[0].A_Rounding
          : 0,
        A_DocStat: vSIHead.ResultSet[0].A_DocStat,
        TaxType: vSIHead.ResultSet[0].A_CUSTFIELD3,
        A_TaxGross: vSIHead.ResultSet[0].A_TaxGross,
        A_Taxable: vSIHead.ResultSet[0].A_Taxable,
        A_Br: vSIHead.ResultSet[0].A_Br,
        A_DiscAmt: vSIHead.ResultSet[0].A_DiscAmt, //decimal
        UnloadingBay: vSIHead.ResultSet[0].UnloadingBin, // Unloading Bin ID
        offer: vSIHead.ResultSet[0].Offer, // Offer Y/N
      })
    );
    // ItemsAliasListSearch(vSIHead.ResultSet[0].A_Loc, sBufferObj.B_Itmcd);

    // GetDefaultDrCrAccount(
    //   vSIHead.ResultSet[0].A_VocTyp,
    //   vSIHead.ResultSet[0].A_PayMode,
    //   vSIHead.ResultSet[0].A_Party,
    //   dispatch
    // );

    fNewDetail(
      vSIHead.ResultSet[0].A_VocNo,
      vSIHead.ResultSet[0].A_Rounding,
      vSIHead.ResultSet[0].A_VocTyp,
      vSIHead?.ResultSet[0]?.A_CUSTFIELD3
    );
  }
};

//API SAVESIDETAIL_GETROW
const fSaveDetail = async (xB_VocNo, sBufferObj, fNewDetail) => {
  const { HeadObject } = OutboundGRV();

  let vSaveSIDetailObj = {
    B_VocTyp: HeadObject?.A_VocTyp,
    B_VocNo: xB_VocNo,
    B_Srno: sBufferObj.B_Srno,
    B_Itmcd: sBufferObj.B_Itmcd,
    B_Qty: sBufferObj.B_Qty,
    B_Unit: sBufferObj.B_Unit,
    B_BaseQty: sBufferObj.B_BaseQty,
    B_URateFc: sBufferObj.B_URateFc,
    B_URateLc: sBufferObj.B_URateLc,
    B_GrossAmt: sBufferObj.B_GrossAmt,
    B_LDiscPerc: sBufferObj.B_LDiscPerc,
    B_LDiscAmt: sBufferObj.B_LDiscAmt,
    B_NetAmt: sBufferObj.B_NetAmt,
    B_LandVal: sBufferObj.B_LandVal,
    B_ExciseTaxAmt: sBufferObj.B_ExciseTaxAmt,
    B_ExciseTaxNetAmt: sBufferObj.B_ExciseTaxNetAmt,
    B_TaxPerc: sBufferObj.B_TaxPerc,
    B_TaxAmt: sBufferObj.B_TaxAmt,
    SplDiscAmt1: sBufferObj.SplDisc,
    TaxDept: sBufferObj.B_TaxDept,
    B_TaxDept2: sBufferObj.B_TaxDept2,
    B_TaxPerc2: sBufferObj.B_TaxPerc2,
    B_TaxAmt2: sBufferObj.B_TaxAmt2,
    B_Ad_CessAmt: 0,
    B_Ad_PCQty: 0,
    B_Ad_PCRate: sBufferObj.AddCess,
    B_Ad_NetCessAmt: sBufferObj.B_NetAddCess,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIDetailObj);
  const vSaveSIDetail = await fExecuteAPI(
    "WMINV04_saveDetail_GETROW",
    FinalObj
  );
  if (vSaveSIDetail?.Type?.toUpperCase() === "SUCCESS") {
    fNewDetail(
      xB_VocNo,
      HeadObject.A_Rounding,
      HeadObject?.A_VocTyp,
      HeadObject?.TaxType
    );
    fAlertToast("SUCCESS", "Successfully Saved");
  } else if (vSaveSIDetail?.Type?.toUpperCase() === "FAILED") {
    fAlertToast("FAILED", vSaveSIDetail.Status);
  }
};

//API "GetItemAttributesPurchase_GETROW"
const GetItemAttributesPurchase = async (dispatch, sBufferObj) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = OutboundGRV();
  let vItemAttributesPurchaseObj = {
    itmCd: sBufferObj.B_Itmcd,
    loc: HeadObject.A_Loc,
    taxType: HeadObject.TaxType,
    unit: sBufferObj.B_Unit,
    party: HeadObject.A_Party,
    TaxDept1: sBufferObj?.B_TaxDept,
    TaxDept2: sBufferObj?.B_TaxDept2,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemAttributesPurchaseObj);
  const vItemAttributesPurchase = await fExecuteAPI(
    "WMINV04_getItemAttributesPurchaseReturn_GETROW",
    FinalObj
  );
  if (vItemAttributesPurchase?.Type?.toUpperCase() === "SUCCESS") {
    return vItemAttributesPurchase.ResultSet;
  } else {
    fAlertToast("FAILED", vItemAttributesPurchase?.response?.data?.Status);
    return [];
  }
};

//API  "PoQtyValidation_GETROW",
const GetPoQtyValidation = async (dispatch, sBufferObj) => {
  const { HeadObject } = OutboundGRV();

  let vPoQtyValidationObj = {
    PoTyp: "", // HeadObject.A_RefDocTyp,
    PoNo: "", //HeadObject.A_RefDocNo,
    GrnType: HeadObject.A_VocTyp,
    GrnNo: HeadObject.A_VocNo,
    SrNo: sBufferObj.B_Srno,
    ItmCd: sBufferObj.B_Itmcd,
    Qty: sBufferObj.B_Qty,
    Unit: sBufferObj.B_Unit,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vPoQtyValidationObj);

  const vPoQtyValidation = await fExecuteAPI(
    "PoQtyValidation_GETROW",
    FinalObj
  );
  if (vPoQtyValidation?.Type?.toUpperCase() === "SUCCESS") {
    return vPoQtyValidation.ResultSet;
  } else {
    fAlertToast("FAILED", vPoQtyValidation?.response?.data?.Status);
    return [];
  }
};

//API  "TsrQtyValidation_GETROW",
const GetTsrQtyValidation = async (dispatch, sBufferObj) => {
  const { HeadObject } = OutboundGRV();

  let vTsrQtyValidationObj = {
    PoTyp: "", //HeadObject.A_RefDocTyp,
    PoNo: "", //HeadObject.A_RefDocNo,
    GrnType: HeadObject.A_VocTyp,
    GrnNo: HeadObject.A_VocNo,
    SrNo: sBufferObj.B_Srno,
    ItmCd: sBufferObj.B_Itmcd,
    Qty: sBufferObj.B_Qty,
    Unit: sBufferObj.B_Unit,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vTsrQtyValidationObj);

  const vTsrQtyValidation = await fExecuteAPI(
    "TsrQtyValidation_GETROW",
    FinalObj
  );

  if (vTsrQtyValidation?.Type?.toUpperCase() === "SUCCESS") {
    return vTsrQtyValidation.ResultSet;
  } else {
    fAlertToast("FAILED", vTsrQtyValidation?.response?.data?.Status);
    return [];
  }
};

//API  "GrnRefNoValidation_GETROW",
const GrnRefNoValidation = async (dispatch) => {
  const { HeadObject } = OutboundGRV();
  let vGrnRefNoValidationObj = {
    TrnTyp: sTrnTyp,
    RefNo: "", // HeadObject.A_RefDocNo,
    Vendor: HeadObject.A_Party,
    VocTyp: HeadObject.A_VocTyp,
    VocNo: HeadObject.A_VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vGrnRefNoValidationObj);
  const vGrnRefNoValidation = await fExecuteAPI(
    "GrnRefNoValidation_GETROW",
    FinalObj
  );
  if (vGrnRefNoValidation?.Type?.toUpperCase() === "SUCCESS") {
    return vGrnRefNoValidation.ResultSet ? vGrnRefNoValidation.ResultSet : [];
  } else {
    fAlertToast("FAILED", vGrnRefNoValidation?.response?.data?.Status);
    return [];
  }
};

//API TransTaxType_GETROW
const GetTransTaxType = async (xLoc, xParty, dispatch) => {
  let vTransTaxTypeObj = {
    loc: xLoc,
    party: xParty,
    taxtype: "IN",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vTransTaxTypeObj);
  const vTransTaxType = await fExecuteAPI("TransTaxType_GETROW", FinalObj);
  if (vTransTaxType?.Type?.toUpperCase() === "SUCCESS") {
    if (vTransTaxType.ResultSet.length > 0) {
      return vTransTaxType.ResultSet[0];
    } else {
      fAlertToast("FAILED", "Default tax object is empty");
      return {};
    }
  } else {
    fAlertToast("FAILED", vTransTaxType?.response?.data?.Status);
    return {};
  }
};

const Get_ToggleDropDown_Load = async (
  xData,
  xType,
  xAcTyp,
  xExact,
  dispatch
) => {
  const { HeadObject } = OutboundGRV();
  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: HeadObject.A_Loc,
    AcTyp: xAcTyp,
    Exact: xExact,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "AccountTransSearch_GETROW",
    FinalObj
  );
  if (vLandedCostDropdownSearch?.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};

//API VALIDATE_HEAD_WMINV03_APPROVE_GETROW
const GetValidateHead_Server = async (dispatch, xApprove) => {
  const { HeadObject } = OutboundGRV();
  const vRdxUserInfoObj = vRdxUserInfo();

  let vValidateHeadApproveObj = {
    xTrnTyp: sTrnTyp,
    xVocTyp: HeadObject.A_VocTyp,
    xVocNo: HeadObject.A_VocNo,
    xPostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    xLoc: HeadObject.A_Loc,
    xParty: HeadObject.A_Party,
    xUserCd: vRdxUserInfoObj?.UserID,
    xRefDocTyp: "", //HeadObject.A_RefDocTyp,
    xRefDocNo: "", //HeadObject.A_RefDocNo,
    xRefDocName: "", // HeadObject.A_RefDocTypName,
    xOfferTrans: HeadObject.offer == "Y" ? true : false,
    xUserGrp: vRdxUserInfoObj?.UserGroupCode,
    xBuyer: HeadObject.A_Buyer,
    xDrAc: HeadObject.A_CrAc,
    xCrAc: HeadObject.A_DrAc,
    xApprove: xApprove,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vValidateHeadApproveObj);
  const vValidateHeadApprove = await fExecuteAPI(
    "WMINV04_validateHead_GETROW",
    FinalObj
  );
  if (vValidateHeadApprove?.Type?.toUpperCase() === "SUCCESS") {
    return true;
  } else if (vValidateHeadApprove.Type === "FAILED") {
    fAlertToast(
      "FAILED",
      !!vValidateHeadApprove.Status
        ? vValidateHeadApprove.Status
        : "Error Validate Head Approve"
    );
    return false;
  } else {
    fAlertToast("FAILED", vValidateHeadApprove.response.data.Status);

    return false;
  }
};

//API CHECK_PO_CREDIT_NOTE_AMOUNT_GETROW
const GetCheckPOCreditNoteAmount = async (dispatch) => {
  const { HeadObject } = OutboundGRV();
  let vCheckPOCreditNoteAmountObj = {
    VocTyp: HeadObject?.A_VocTyp,
    VocNo: HeadObject?.A_VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(
    vCheckPOCreditNoteAmountObj
  );

  const vCheckPOCreditNoteAmount = await fExecuteAPI(
    "CHECK_PO_CREDIT_NOTE_AMOUNT_GETROW",
    FinalObj
  );
  if (vCheckPOCreditNoteAmount?.Type?.toUpperCase() === "SUCCESS") {
    return vCheckPOCreditNoteAmount.ResultSet.length > 0
      ? vCheckPOCreditNoteAmount.ResultSet
      : [];
  } else if (vCheckPOCreditNoteAmount.response.status == 400) {
    fAlertToast("FAILED", vCheckPOCreditNoteAmount.response.data.Status);
    return [];
  } else if (vCheckPOCreditNoteAmount.response.status == 500) {
    fAlertToast("FAILED", vCheckPOCreditNoteAmount.response.data.Status);
    return [];
  }
};

//API VALIDATE_COST_VARIANCE_GETROW
const GetValidateCostVariance = async (dispatch) => {
  const { HeadObject } = OutboundGRV();
  const vRdxUserInfoObj = vRdxUserInfo();
  // let vValidateCostVarianceObj = {
  //   voctyp: "WG002",
  //   vocno: "GRSDC00211",
  //   usercd: "001",
  // };
  let vValidateCostVarianceObj = {
    voctyp: HeadObject?.A_VocTyp,
    vocno: HeadObject?.A_VocNo,
    usercd: vRdxUserInfoObj?.UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vValidateCostVarianceObj);

  const vValidateCostVariance = await fExecuteAPI(
    "VALIDATE_COST_VARIANCE_GETROW",
    FinalObj
  );
  if (vValidateCostVariance?.Type?.toUpperCase() === "SUCCESS") {
    return vValidateCostVariance.ResultSet.length > 0
      ? vValidateCostVariance.ResultSet
      : [];
  } else if (vValidateCostVariance.response.status == 400) {
    fAlertToast("FAILED", vValidateCostVariance.response.data.Status);
    return [];
  } else if (vValidateCostVariance.response.status == 500) {
    fAlertToast("FAILED", vValidateCostVariance.response.data.Status);
    return [];
  }
};

//API SALESGROUP
const GetSalesGroups = async (xA_Loc) => {
  const vSalesGroups = await fExecuteAPI("SALESGROUPS_GETROW", xA_Loc);
  if (vSalesGroups.Type == "SUCCESS") {
    return vSalesGroups.ResultSet;
  } else {
    fAlertToast("FAILED", vSalesGroups.Message);
    return [];
  }
};

var vheaderArrow = 0;
const fRightClick = (e) => {
  vheaderArrow !== 1 ? (vheaderArrow = vheaderArrow + 1) : (vheaderArrow = 1);

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const fLeftClick = (e) => {
  vheaderArrow !== 0 ? (vheaderArrow = vheaderArrow - 1) : (vheaderArrow = 0);
  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

//defcustomersetting_GETROW
const GetDefcustomersetting = async (xAcCd, xLoc, xOutboundType, dispatch) => {
  const { HeadObject } = OutboundGRV();
  let vdefcustomersettingObj = {
    accd: xAcCd,
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vdefcustomersettingObj);

  const vdefcustomersetting = await fExecuteAPI(
    "defcustomersetting_GETROW",
    FinalObj
  );
  if (vdefcustomersetting.Type == "SUCCESS") {
    if (
      vdefcustomersetting.ResultSet.length > 0 &&
      !!vdefcustomersetting.ResultSet[0].SalesMan
    ) {
      dispatch(
        Wms_HeadObject_Buyer_Set({
          A_Buyer: !!vdefcustomersetting.ResultSet[0].SalesMan
            ? vdefcustomersetting.ResultSet[0].SalesMan
            : HeadObject.A_Buyer,
        })
      );
    }
  } else {
    fAlertToast(
      "FAILED",
      !!vdefcustomersetting.Message
        ? vdefcustomersetting.Message
        : "Error in default setting customer"
    );
  }
};

//API WMSSI_ITEMSTOCK_GETROW // for viewing ERP & WMS
const GetItemStock = async (
  xItemCode,
  xSrno,
  xLoc,
  setItemStock,
  xpackQty = 0
) => {
  const { HeadObject } = OutboundGRV();
  let vItemStockObj = {
    itmCd: xItemCode.trim(),
    loc: xLoc,
    invoiceTyp: "",
    vocTyp: HeadObject.A_VocTyp,
    vocNo: HeadObject.A_VocNo,
    srNo: xSrno,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemStockObj);

  const vItemStock = await fExecuteAPI("WMINV04_itemStock_GETROW", FinalObj);
  if (vItemStock?.Type?.toUpperCase() === "SUCCESS") {
    let ipackQty = fcovertToNumber(xpackQty);
    let RPStock =
      ipackQty === 0
        ? 0
        : fcovertToNumber(vItemStock.ResultSet.rpStock) / ipackQty;
    setItemStock((obj) => ({
      ...obj,
      rpStock: Number(RPStock).toFixed(3),
    }));
  } else if (
    vItemStock.response.status == 400 ||
    vItemStock.response.status == 500
  ) {
    fAlertToast("FAILED", vItemStock.response.data.Status);
  }
};
export const xGCSearchBtn_Columns_DropdownSearch = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "AcCd", headerName: "Code", width: 100 },
  { field: "Name2", headerName: "Name2", width: 450 },
  // { field: "Name1", headerName: "Name1", width: 220 },
];
const Get_GCSearchBtn = async (xData, xType, xExact = "N") => {
  const vRdxUserInfoObj = vRdxUserInfo();
  let vLoaded_Cost_FreightObj = {
    v_Data: xData,
    v_Type: xType,
    v_TrnTyp: sTrnTyp,
    v_UserId: vRdxUserInfoObj.UserID,
    Exact: xExact,
  };
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "Common_transpartylist_GETROW",
    vLoaded_Cost_FreightObj
  );
  if (vLandedCostDropdownSearch.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};
const GetOSAmount = async (xLoc, xParty, setOsAmount) => {
  const { HeadObject } = OutboundGRV();
  let vOsAmtObj = {
    loc: xLoc,
    unit: xParty,
  };
  if (HeadObject.A_DocStat === "ENTER") {
    const vOsAmt = await fExecuteAPI("Common_partyosamtt_GETROW", vOsAmtObj);
    if (
      vOsAmt?.Type?.toUpperCase() === "SUCCESS" &&
      vOsAmt?.ResultSet?.length > 0
    ) {
      setOsAmount((obj) => ({
        ...obj,
        NetOsAmt: vOsAmt.ResultSet[0].NetAmtWithoutPDC,
        PDCAmt: vOsAmt.ResultSet[0].PDCAmt,
        BalanceOsAmt: vOsAmt.ResultSet[0].NetAmtAfterPDC,
      }));
    } else {
      fAlertToast(
        "FAILED",
        vOsAmt.response.data.message || vOsAmt.response.data.Status
      );
    }
  } else {
    setOsAmount((obj) => ({
      ...obj,
      NetOsAmt: 0,
      PDCAmt: 0,
      BalanceOsAmt: 0,
    }));
  }
};

export const GetAttributes = async (
  setObjectRights,
  setUser_Doc_Arr,
  setDocLoading,
  setUnloading,
  setCurrency,
  setOutboundType
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    userCode: vRdxUserInfoObj.UserID,
    userGroupCode: vRdxUserInfoObj.UserGroupCode,
  };
  const iAttributes = await WMSGRV_GRVAttributes_GETROW(vObj);
  if (iAttributes?.status === 200) {
    setUser_Doc_Arr(iAttributes?.data?.ResultSet?.UserDoc);
    setObjectRights(iAttributes?.data?.ResultSet?.Rights);
    setDocLoading(iAttributes?.data?.ResultSet?.DocLoading);
    setUnloading(iAttributes?.data?.ResultSet?.UnloadingBay);
    setCurrency(iAttributes?.data?.ResultSet?.Currency);
    setOutboundType(iAttributes?.data?.ResultSet?.Type);
    return iAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};
export const getTransItemStockUOM = async (
  setTransItemStockObj,
  xB_Itmcd,
  xB_Unit,
  xLoc
) => {
  let ApiObj = await Get_TransItemStockUOM(xB_Itmcd, xB_Unit, xLoc);
  if (ApiObj?.length > 0) {
    setTransItemStockObj({
      RPStock: ApiObj[0]?.RPStock,
      MSP: ApiObj[0].MSP,
      CostPr: ApiObj[0].CostPr,
      LPRate: ApiObj[0].LPRate,
    });
  }
};

export {
  // rows,
  // columns,
  GetOSAmount,
  Get_GCSearchBtn,
  fRightClick,
  fLeftClick,
  sPaymode,
  sTax,
  sFocFlagArr,
  TypeArr,
  fKeyOutboundGRV,
  fKeyOutboundGRVContent,
  // Api
  GetCheckboxUserRights,
  GetBuyer,
  GetSalesman,
  GetDefaultDrCrAccount,
  GetLocation,
  GetUnitArr,
  GetItemLineArr,
  GetUnitRateArr,
  GetIncentiveGroup,
  GetItemFullSearchArr,
  GetItemSearch,
  fItemCodeDependency,
  GetSearchItem,
  GetTransTaxType,
  GrnRefNoValidation,
  GetItemAttributesPurchase,
  GetPoQtyValidation,
  GetTsrQtyValidation,
  GetSalesGroups,
  GetOtherSlabs,
  GetSupervisorSlabs,
  //save
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fValidateItemsAttributes,
  fGetValidationDetailInfo,
  fSaveHead,
  fSaveDetail,
  fDisplay,

  //reverse
  fCloseReverseTransactionModal,
  fOpenReverseTransactionModal,
  fReverse,

  //Head functions
  fDefaultPayload,

  //Approve
  GetValidateHead_Server,
  GetCheckPOCreditNoteAmount,
  GetValidateCostVariance,

  //src doc
  Get_ToggleDropDown_Load,
  //GCLoadedCost
  GetDefcustomersetting,

  //GetItemStock
  GetItemStock,

  //grid history
  GetSalesHistory,
  fSaveHead_Detsil,
};
